import { Folder, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';

export const enum MoveKind {
    Normal,
    SharedFolder,
}
export default (sourceFolder: Folder, destinationFolder: Folder) => {
    if (
        (sourceFolder && sourceFolder.treeType === SHARED_FOLDERS_TREE_TYPE) ||
        (destinationFolder && destinationFolder.treeType === SHARED_FOLDERS_TREE_TYPE)
    ) {
        return MoveKind.SharedFolder;
    }

    return MoveKind.Normal;
};
